<div class="content-box principal-content">
    <div class="table-menu">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <a class="btn-back" mat-raised-button (click)="goBack()">
                        <mat-icon aria-hidden="false" aria-label="keyboard_backspace">keyboard_backspace</mat-icon>
                        Volver
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div class="container">
        <p class="principal-title">Buscador de Eventos</p>
        <div class="content-box-search">
            <div class="col-md-4">
                <mat-form-field class="w-100">
                    <mat-label>
                        <mat-icon aria-hidden="false" aria-label="date_range">date_range</mat-icon>Desde/Hasta
                    </mat-label>
                    <input matInput [matDatepicker]="picker" placeholder="Desde/hasta">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-datepicker #hasta></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col-md-4">
                <div class="col-md-12">
                    <button class="button-primary" (click)="search()" >Buscar Eventos</button>
                </div>            
            </div>
        </div>
        <div class="result">
            <p><strong>{{ dataSource?.data?.length }}</strong> resultados de búsqueda</p>
        </div>
        <div class="table-result">
            <table mat-table class="w-100" [dataSource]="dataSource.data" matSort aria-label="Elements">
                <caption></caption>
                <ng-container matColumnDef="number">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col">N°</th>
                    <td mat-cell *matCellDef="let row">{{row.number}}</td>
                </ng-container>
                <ng-container matColumnDef="event">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col">Evento</th>
                    <td mat-cell *matCellDef="let row">{{row.event}}</td>
                </ng-container>
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col">Fecha</th>
                    <td mat-cell *matCellDef="let row">{{row.date}}</td>
                </ng-container>
                <ng-container matColumnDef="seeDownload">
                    <th mat-header-cell *matHeaderCellDef scope="col">Ver / Descargar</th>
                    <td mat-cell *matCellDef="let row">    
                        <button class="button-secondary event">
                            <mat-icon aria-hidden="false" aria-label="article">article</mat-icon>Ver Evento
                        </button>
                        <button class="button-secondary excel">
                            <mat-icon aria-hidden="false" aria-label="get_app">get_app</mat-icon>Excel
                        </button>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                    [class.selected]="row.isSelected"></tr>
            </table>
        </div>


    </div>
</div>


